import { MAX_DESKTOP_BREAKPOINT } from '../constants/_breakpoints';

const mapSizesToProps = ({ width }) => ({
  isMobile: width < parseInt(MAX_DESKTOP_BREAKPOINT, 10),
});

export default mapSizesToProps;
